import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';

/**
 * Centered-card shell used by the auth feature (login / register / verify).
 * Renders the VendorHub logo, a max-width card housing the `<router-outlet>`,
 * and a "Back to homepage" link.
 */
@Component({
  selector: 'vh-auth-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="vh-auth">
      <a class="vh-auth__logo" routerLink="/" aria-label="VendorHub home">
        <span>Vendor</span><strong>Hub</strong>
      </a>

      <section class="vh-auth__card">
        <router-outlet />
      </section>

      <a class="vh-auth__back" routerLink="/">← Back to homepage</a>
    </div>
  `,
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent {}
